import { ref, computed } from "vue"
import { defineStore } from "pinia"

import * as settingsApi from "@/api/settingsApi.js"

import * as quasarUtils from "@/services/quasarUtils.js"

import i18n from "@/plugins/i18n.js"

export const useGlobalStore = defineStore("global", () => {
  const globalConfig = ref({})
  const globalSettings = ref({})

  const fetchConfigs = async () => {
    try {
      const [globalConfigData, globalSettingsData, mainModuleSettingsData] = await Promise.all([
        settingsApi.getGlobalConfiguration(),
        settingsApi.getGlobalSettings(),
        //redundant call temporarily to support top bar settings globally
        settingsApi.getMainModuleSettings()
      ])

      globalConfig.value = globalConfigData
      globalSettings.value = globalSettingsData

      globalSettings.value.loginPageTopBarAccentColor = mainModuleSettingsData.loginPageTopBarAccentColor
      globalSettings.value.loginPageTopBarBackgroundColor = mainModuleSettingsData.loginPageTopBarBackgroundColor
      globalSettings.value.loginPageTopBarColor = mainModuleSettingsData.loginPageTopBarColor
    } catch (err) {
      if (err?.response?.status === 500) {
        document.write("Error: Invalid configuration, invalid or missing license key, please contact portal administrator")
      }
      quasarUtils.handleError(err)
    }
  }

  const setGlobalSettings = async (settings) => {
    await settingsApi.setGlobalSettings(settings)
    await fetchConfigs()
    quasarUtils.showToast({ message: i18n.global.t("_RSFAP_SHARED_SAVED") })
  }

  const redirectToSsoPortal = () => {
    const redirectPortalUrl = globalConfig.value.ssoSettings.customSso.portalUrl
      ? globalConfig.value.ssoSettings.customSso.portalUrl
      : "http://no-portal-url-specified.example.com"
    const port = window.location.port ? ":" + window.location.port : ""
    const currentOriginAndPath = `${window.location.protocol}//${window.location.hostname}${port}${window.location.pathname}`
    const currentOriginAndPathInBase64 = btoa(currentOriginAndPath)
    const redirectionParameter = currentOriginAndPathInBase64
    const redirectionAddress = `${redirectPortalUrl}?url=${redirectionParameter}`
    window.location.replace(redirectionAddress)
  }

  const buildVersion = computed(() => {
    const version = globalConfig.value.appVersion

    //temporary ignore also local-backend because it will be like that for local file deployments
    const backendBranchName = globalConfig.value.buildBranch === "master" ? "" : globalConfig.value.buildBranch

    const metaAppVersion = document.querySelector(`meta[name="app-version"]`)?.getAttribute("content").toString().trim()

    //temporary ignore also local-frontend because it will be like that for local file deployments
    const frontendBranchname = metaAppVersion === "master" ? "" : metaAppVersion

    if (backendBranchName && frontendBranchname) {
      if (backendBranchName === frontendBranchname) {
        return `(${backendBranchName})`
      }
      return `(${backendBranchName} / ${frontendBranchname})`
    }
    if (backendBranchName) {
      return `(${backendBranchName})`
    }
    if (frontendBranchname) {
      return `(${frontendBranchname})`
    }
    // this is the common case for production releases
    return version
  })

  return { globalConfig, globalSettings, buildVersion, fetchConfigs, setGlobalSettings, redirectToSsoPortal }
})
